import { useState } from "react";
import { host } from '../constants';

export const useFranchiseSerials = () => {
    return useProvideFranchiseSerials();
};

function useProvideFranchiseSerials() {
    const [franchiseSerials, setFranchiseSerials] = useState(null);

    const loadSerials = async (token, franchiseId) => {
        const data = await loadAllByHttp(token, franchiseId);
        setFranchiseSerials(data || []);
        return data;
    };

    const createFranchiseSerial = async (token, franchiseId, serialId, orderIndex) => {
        const created = await createByHttp(token, franchiseId, serialId, orderIndex);
        if (franchiseSerials) {
            setFranchiseSerials(prev => [...prev, created].sort((a, b) => a.orderIndex - b.orderIndex));
        }
        return created;
    };

    const updateFranchiseSerial = async (token, franchiseId, serialId, orderIndex) => {
        const updated = await updateByHttp(token, franchiseId, serialId, orderIndex);
        if (franchiseSerials) {
            setFranchiseSerials(prev =>
                prev.map(fs => fs.serialId === serialId ? updated : fs)
                    .sort((a, b) => a.orderIndex - b.orderIndex)
            );
        }
        return updated;
    };

    const deleteFranchiseSerial = async (token, franchiseId, serialId) => {
        const deleted = await deleteByHttp(token, franchiseId, serialId);
        if (franchiseSerials) {
            const updated = franchiseSerials.filter(fs => fs.serialId !== serialId);
            setFranchiseSerials(updated);
        }
        return deleted;
    };

    return {
        franchiseSerials,
        loadSerials,
        createFranchiseSerial,
        updateFranchiseSerial,
        deleteFranchiseSerial,
    };
}

async function loadAllByHttp(token, franchiseId) {
    const url = `${host}/api/franchise/${franchiseId}/serials`;
    const response = await fetch(url, {
        method: 'GET',
        headers: {
            'Accept': 'application/json',
            'Authorization': `Bearer ${token}`,
        },
    });
    if (!response.ok) return [];
    return await response.json();
}

async function createByHttp(token, franchiseId, serialId, orderIndex) {
    const url = `${host}/api/franchise/${franchiseId}/serials/${serialId}`;
    const response = await fetch(url, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify(orderIndex),
    });
    return await response.json();
}

async function updateByHttp(token, franchiseId, serialId, orderIndex) {
    const url = `${host}/api/franchise/${franchiseId}/serials/${serialId}`;
    const response = await fetch(url, {
        method: 'PUT',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify(orderIndex),
    });

    if (!response.ok) throw new Error("Failed to update order");

    if (response.status === 204 || response.headers.get("content-length") === "0") {
        return { serialId, orderIndex };
    }

    return await response.json();
}

async function deleteByHttp(token, franchiseId, serialId) {
    const url = `${host}/api/franchise/${franchiseId}/serials/${serialId}`;
    const response = await fetch(url, {
        method: 'DELETE',
        headers: {
            'Accept': 'application/json',
            'Authorization': `Bearer ${token}`,
        },
    });
    return await response.json();
}